module.exports = __webpack_public_path__ + "img/icon-vocabulario.5c180d8d.svg";